'use strict';
var util = require('../util');
var core = require('../core');

var _events = {};
var pageEvents = ['appear', 'disappear', 'scroll'];
function getPageMethodName(name) {
  var result = 'on' + core._captal(name);
  // fix for android 7.6.0
  if (util.osName == 'android' && util.appVersion == '7.6.0' && /appear|disappear/.test(name)) {
    result = name;
  }
  return result;
}

module.exports = {
  appVersion: '7.6.0',
  
  isInstalledApp: util.actionMapping('isInstalledApp'),

  subscribe: function(opt) {
    var self = this;
    var name = opt.action;
    var handle = opt.handle;
    var messageName;

    function mainHandler(e) {
      _events[name] && _events[name].length && _events[name].forEach(function(func) {
        func && func(e);
      });
    }

    function registerPageEvents() {
      if (messageName) {
        window.DPApp && (window.DPApp[getPageMethodName(name)] = mainHandler);
        opt.success && opt.success();
      }
    }

    if (_events[name]) {
      opt.success && opt.success();
      _events[name].push(handle);
    } else {
      if (pageEvents.indexOf(name) !== -1) {
        messageName = 'on' + self._captal(name);
        if (name == 'scroll') {
          // 仅scroll事件需要toggle开关
          this._send(messageName, {
            success: registerPageEvents
          });
        } else {
          // 不然就直接注册上了
          registerPageEvents();
        }
      } else {
        this._send('subscribe', {
          action: name,
          success: opt.success,
          handle: mainHandler
        });
      }

      _events[name] = [handle];
    }
  },

  unsubscribe: function(opt) {
    var name = opt.action;
    var success = opt.success;
    var handle = opt.handle;
    var self = this;

    var index = _events[name] ? _events[name].indexOf(handle) : -1;

    function unregisterPageEvents() {
      self[callbackName] = function () {};
    }

    if (index != -1) {
      _events[name].splice(index, 1);
      success && success();
      if (!_events[name].length) {
        _events[name] = null;
      }
    } else if (!handle) {
      _events[name] = null;
    }

    if (!_events[name]) {
      // unregister
      // if is page event
      if (pageEvents.indexOf(name) !== -1) {
        var messageName = 'off' + self._captal(name);
        var callbackName = 'on' + self._captal(name);
        // 与安卓确认
        if (name == 'scroll') {
          this._send(messageName, {
            success: unregisterPageEvents
          });
        } else {
          unregisterPageEvents();
        }
      } else {
        this._send('unsubscribe', {
          action: name,
          success: success
        });
      }
    }
  },
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dp/dpapp/lib/patch/patch-7.6.0.js
// module id = tdh+
// module chunks = 0